import React from 'react'
import ANavbar from "../Components/About/ANavbar/ANavbar"
import AHeader from "../Components/About/AHeader/AHeader"
import AboutUs from '../Components/About/AboutUs/AboutUs'
import CeoMessage from '../Components/About/CeoMessage/CeoMessage'
// import Amenities from '../Components/About/Amenities/Amenities'
// import OurTeam from '../Components/Home/OurTeam/OurTeam'
// import AffiliateTeam from '../Components/About/AffiliateTeam/AffiliateTeam'
import Surrounding from '../Components/About/Surrounding/Surrounding'
import InternationalPartners from '../Components/About/InternationalPartners/InternationalPartners'
import OurPartners from '../Components/About/OurPartners/OurPartners'
import Footer from '../Components/About/Footer/Footer'


const About = () => {
  return (
    <div>
      <ANavbar />
      <AHeader />
      <AboutUs />
      <CeoMessage />
      {/* <OurTeam /> */}
      {/* <AffiliateTeam /> */}
      <Surrounding />
      <InternationalPartners />
      <OurPartners />
      <Footer />
    </div>
  )
}

export default About